import ApiService from "./api.service";

export const DlGroupService = {
    getMetaInfo: async function () {
        const response = await ApiService.get('/info/meta');
        return response.data;
    },
    getInfoPage: async function (language) {
        const params = new URLSearchParams();
        params.append('set_request_language', language);
        const response = await ApiService.get('/info/page?' + params.toString());
        return response.data;
    }
};